/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-cycle */

import "./style.css";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import MDTypography from "components/Basics/MDTypography";
import lod_ from "lodash";
import FormActions from "redux-react/actions/formAction";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import i18n from "i18n";
import DictionaryMenu from "pages/settings/filters/DictionaryMenu";
import SettingsActions from "redux-react/actions/settingsActions";
import {
	Divider,
	Icon,
	IconButton,
	Tooltip,
	Chip,
	CircularProgress,
	Menu,
	MenuItem,
	Grid,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import InputBoolean from "./Inputs/InputBoolean";
import InputDelay from "./Inputs/InputDelay";
import InputPhone from "./Inputs/InputPhone";
import InputDate from "./Inputs/InputDate";
import InputEmail from "./Inputs/InputEmail";
import InputString from "./Inputs/InputString";
import InputNumber from "./Inputs/InputNumber";
import InputCode from "./Inputs/InputCode";
import InputImageList from "./Inputs/InputImageList";
import InputCron from "./Inputs/InputCron";
import InputWebhook from "./Inputs/InputWebhook";
import InputLabel from "./Inputs/InputLabel";
import InputActions from "./Inputs/InputActions";
import InputMapping from "./Inputs/InputMapping/index";
import ReactJson from "react-json-view";
import MDButton from "components/Basics/MDButton";
import InputHtml from "./Inputs/InputHtml";
import InputApiKey from "./Inputs/InputApiKey";
import InputTextarea from "./Inputs/InputTextarea";
import InputLabelLanguage from "./Inputs/InputLabelLanguage";
import { useTranslateActions } from "hooks/useTranslateActions";
import { useLanguages } from "hooks/useLanguages";
import { Translate } from "@mui/icons-material";
import Joi from "joi";
import { t } from "i18next";
import InputUploadImage from "./Inputs/InputUploadImage";
import InputUploadDocument from "./Inputs/InputUploadDocument";
import { getLabel, getLabelPath } from "helpers/dictionary";
import LittleArrayForm from "./Inputs/LittleArrayForm";
import { isUserSystem } from "redux-react/reducers/userReducers";

/**
 * Component for input
 */
export const FormInput = ({
	item,
	path,
	datas,
	handleChange,
	regexEmail = "",
	listOfApis = [],
	listOfDico = {},
	errorUniqueFields,
	disabled: disabledProp = false,
	actions,
	language,
	languages,
	...rest
}) => {
	const [anchorElOutput, setAnchorElOutput] = useState(null);
	const profile = useSelector(selectCurrentProfile);

	if (lod_.isEmpty(item)) {
		return null;
	}

	let type = item.type;
	let label = getLabel(item.label, profile?.language);
	let codes = item.codes || [];

	let value = lod_.get(datas, path);
	let disabled = disabledProp || !(item?.actions?.edit ?? true);
	let error = errorUniqueFields?.includes(path);

	console.log("->", label, listOfApis);

	const onChange = value => {
		handleChange(path, value);
	};

	const onChangeLabel = (target, value) => {
		handleChange(`${path}.${target}`, value);
	};
	const onChangeValueKey = valueDico => {
		const keysPath = Object.keys(value || {});
		const pathOfDico = keysPath[0];

		let object = {};
		object[pathOfDico] = valueDico;

		handleChange(path, object);
	};

	const onChangePathKey = key => {
		const valuePath = value[path] || "";

		let object = {};
		object[key] = valuePath;

		handleChange(path, object);
	};

	// Add a star to the label if the field is required
	if (item.isRequired) {
		label = (
			<span>
				{label}
				<span className="mandatoryField">*</span>
			</span>
		);
	}

	switch (type) {
		case "html":
			return (
				<InputHtml
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "mapping":
			return (
				<InputMapping
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "labels":
			return (
				<InputLabel
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "cron":
			return <InputCron label={label} item={item} />;
		case "webhook":
			return (
				<InputWebhook
					label={label}
					value={value}
					apiKey={lod_.get(datas, "apiKey")}
					onChange={onChange}
					item={item}
				/>
			);
		case "apiKeyGenerate":
			return <InputApiKey label={label} value={value} onChange={onChange} />;
		case "imageList":
			return (
				<InputImageList
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "boolean":
			return (
				<InputBoolean
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
				/>
			);
		case "phone":
			return (
				<InputPhone
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "date":
		case "datetime":
			return (
				<InputDate
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "email":
			return (
				<InputEmail
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					regexEmail={regexEmail}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "string":
			return (
				<InputString
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
					{...rest}
				/>
			);
		case "textarea":
			return (
				<InputTextarea
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					{...rest}
				/>
			);
		case "number":
			return (
				<InputNumber
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		case "delay":
			return (
				<InputDelay
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
				/>
			);
		case "code":
			return (
				<InputCode
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					codes={codes}
					path={path}
					item={item}
				/>
			);
		case "actions":
			return (
				<InputActions
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);

		case "dictionaryPath":
			return (
				<MDBox
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					alignItems="stretch"
					component="fieldset"
					style={{
						borderRadius: "0.375rem 0 0 0.375rem"
					}}
					className="boxInputStyle"
					borderRadius="md"
				>
					<MDBox>
						<legend
							style={{
								lineHeight: 1.5,
								fontSize: "0.875rem",
								color: "#344767",
								fontWeight: 400
							}}
						>
							{label}
						</legend>
						<MDBox>
							<MDTypography variant="body2" fontSize="medium" fontWeight="bold">
								{getLabelPath(listOfDico, value, language, t("CHANNEL.MAPPING.undefined"))}
							</MDTypography>
						</MDBox>
					</MDBox>
					<MDBox display="flex" align="center">
						<Tooltip placement="top" title={i18n.t("CHANNEL.MAPPING.set")}>
							<MDBox
								className="endButtonboxInputStyle"
								display="flex"
								justifyContent="center"
								alignItems="center"
								bgColor="light"
								style={{
									borderRadius: "0.375rem 0 0 0.375rem",
									borderLeft: "1px solid #d2d6da"
								}}
								onClick={e => setAnchorElOutput(e.target)}
							>
								<Icon fontSize="small">menu</Icon>
							</MDBox>
						</Tooltip>
						<Tooltip placement="top" title={i18n.t("CHANNEL.MAPPING.clear")}>
							<MDBox
								className="endButtonboxInputStyle"
								display="flex"
								justifyContent="center"
								alignItems="center"
								bgColor="light"
								onClick={() => {
									onChange(null);
								}}
							>
								<Icon fontSize="small">close</Icon>
							</MDBox>
						</Tooltip>
					</MDBox>

					<DictionaryMenu
						placement="top"
						dictionary={listOfDico}
						anchorEl={anchorElOutput}
						handleInsertText={e => {
							setAnchorElOutput(null);
							onChange(e);
						}}
						handleClose={() => setAnchorElOutput(null)}
					/>
				</MDBox>
			);
		case "labelLanguage": {
			return (
				<InputLabelLanguage
					label={label}
					value={value}
					onChangeLabel={onChangeLabel}
					onChange={onChange}
					disabled={disabled}
					path={path}
					error={error}
					actions={actions}
					languages={languages}
				/>
			);
		}

		case "keyDictionary": {
			const keysPath = Object.keys(value || {});
			const pathOfDico = keysPath[0];
			const valuePath = value[pathOfDico] || "";
			return (
				<MDBox
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					alignItems="stretch"
					component="fieldset"
					style={{
						borderRadius: "0.375rem 0 0 0.375rem"
					}}
					className="boxInputStyle"
					borderRadius="md"
				>
					<MDBox
						display="flex"
						flexDirection="column"
						style={{
							width: "100%"
						}}
					>
						<MDBox
							display="flex"
							justifyContent="space-between"
							flexDirection="row"
							pb={1}
							style={{
								width: "100%"
							}}
						>
							<MDBox>
								<legend
									style={{
										lineHeight: 1.5,
										fontSize: "0.875rem",
										color: "#344767",
										fontWeight: 400
									}}
								>
									{label}
								</legend>
								<MDBox>
									<MDTypography variant="body2" fontSize="medium" fontWeight="bold">
										{getLabelPath(listOfDico, pathOfDico, language, t("CHANNEL.MAPPING.undefined"))}
									</MDTypography>
								</MDBox>
							</MDBox>

							<MDBox display="flex" align="center">
								<Tooltip placement="top" title={i18n.t("CHANNEL.MAPPING.set")}>
									<MDBox
										className="endButtonboxInputStyle"
										display="flex"
										justifyContent="center"
										alignItems="center"
										bgColor="light"
										style={{
											borderRadius: "0.375rem 0 0 0.375rem",
											borderLeft: "1px solid #d2d6da"
										}}
										onClick={e => setAnchorElOutput(e.target)}
									>
										<Icon fontSize="small">menu</Icon>
									</MDBox>
								</Tooltip>
								<Tooltip placement="top" title={i18n.t("CHANNEL.MAPPING.clear")}>
									<MDBox
										className="endButtonboxInputStyle"
										display="flex"
										justifyContent="center"
										alignItems="center"
										bgColor="light"
										onClick={() => {
											onChange({});
										}}
									>
										<Icon fontSize="small">close</Icon>
									</MDBox>
								</Tooltip>
							</MDBox>
						</MDBox>

						<InputString
							disabled={disabled}
							error={error}
							value={valuePath}
							onChange={onChangeValueKey}
							item={item}
							listOfApis={listOfApis}
							path={path}
						/>
					</MDBox>

					<DictionaryMenu
						placement="top"
						dictionary={listOfDico}
						anchorEl={anchorElOutput}
						handleInsertText={e => {
							setAnchorElOutput(null);
							onChangePathKey(e);
						}}
						handleClose={() => setAnchorElOutput(null)}
					/>
				</MDBox>
			);
		}
		case "uploadedImage": {
			return (
				<InputUploadImage
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		}
		case "uploadedDocument": {
			return (
				<InputUploadDocument
					disabled={disabled}
					error={error}
					label={label}
					value={value}
					onChange={onChange}
					item={item}
					listOfApis={listOfApis}
					path={path}
				/>
			);
		}
		default:
			return (
				<Grid
					size="grow"
					sx={{
						flexBasis: "66.666%",
						minWidth: "66.666%"
					}}
				>
					<MDInput
						disabled={disabled}
						error={error}
						type={type}
						className="dialogInput"
						label={label}
						value={value}
						onChange={e => onChange(e.target.value)}
						style={{
							backgroundColor: disabled ? "light" : "white"
						}}
					/>
				</Grid>
			);
	}
};

/**
 * Helper function to check if a level item has labelLanguage children
 * @param {Object} itemsObject - The items object to check
 * @returns {Array} - Array of labelLanguage field keys found in direct children
 */
const getLabelLanguageFields = itemsObject => {
	if (!itemsObject || typeof itemsObject !== "object") return [];
	return Object.entries(itemsObject)
		.filter(([_, fieldItem]) => fieldItem?.type === "labelLanguage")
		.map(([key, _]) => key);
};

/**
 * Helper function to check if all children of a level item are advanced
 * @param {Object} items - The items object to check
 * @returns {Boolean} - True if all children have advanced === true
 */
const allChildrenAdvanced = items => {
	if (!items || typeof items !== "object") return false;
	const entries = Object.entries(items);
	if (entries.length === 0) return false;
	return entries.every(([_, child]) => child?.advanced === true);
};

/**
 * Component for create a form from a dictionary
 */
const LittleFormBusiness = ({
	item = {},
	object,
	metadatasSkeleton,
	handleChange,
	hiddenFields = [],
	level = 0,
	path = null,
	listAPIs = null,
	errorUniqueFields,
	display = "column",
	flex = 1,
	context = null,
	languages = [],
	actions = {},
	collapseActions,
	disabled,
	expandedState,
	setExpandedState,
	baseDictionary,
	showAdvanced: showAdvancedProp
}) => {
	const userSystem = useSelector(isUserSystem);
	const user = useSelector(state => state.user);
	const profile = useSelector(selectCurrentProfile);
	const assistantID = profile?.assistantID;
	const language = profile?.language || user?.language || "fr";

	const [regexEmail, setRegexEmail] = useState("");
	const [listOfApis, setListOfApis] = useState([]);
	const [keyDictionary, setKeyDictionary] = useState({});
	const [localExpandedState, setLocalExpandedState] = useState({});
	const [localShowAdvanced, setLocalShowAdvanced] = useState(false);

	const [levelTranslating, setLevelTranslating] = useState(false);
	const [menuAnchorEl, setMenuAnchorEl] = useState(null);

	const [translationContext, setTranslationContext] = useState(null);

	const { translateV2Dataset } = actions;

	let keys = Object.keys(object);
	const dispatch = useDispatch();

	// Use parent state if available, otherwise use local state
	const expanded = level === 0 ? localExpandedState : expandedState;
	const setExpanded = level === 0 ? setLocalExpandedState : setExpandedState;
	const showAdvanced = level === 0 ? localShowAdvanced : showAdvancedProp;

	const isItemAdvanced = item.advanced === true;

	const onChangeInputs = (path, e) => {
		let value = e.updated_src;
		handleChange(path, value);
	};

	const handleTranslateMenuOpen = (e, labelLanguageFieldsData, currentPathData) => {
		e.stopPropagation();
		e.preventDefault();
		setMenuAnchorEl(e.currentTarget);
		setTranslationContext({
			labelLanguageFields: labelLanguageFieldsData,
			currentPath: currentPathData
		});
	};

	const handleTranslateMenuClose = e => {
		e?.stopPropagation();
		e?.preventDefault();
		setMenuAnchorEl(null);
		setTranslationContext(null);
	};

	useEffect(() => {
		const onSuccess = res => {
			setRegexEmail(res.regex);
		};
		const onSuccessApis = res => {
			setListOfApis(res?.apisList || []);
		};

		if (regexEmail === "") {
			dispatch(FormActions.getRegexLittleForm("email", onSuccess));
		}
		if (lod_.isEmpty(listOfApis)) {
			if (!lod_.isEmpty(listAPIs)) {
				setListOfApis(listAPIs);
			} else {
				dispatch(FormActions.getListApis(assistantID, onSuccessApis));
			}
		}
		if (lod_.isEmpty(keyDictionary)) {
			dispatch(
				SettingsActions.getDictionary("context", res =>
					setKeyDictionary({ context: res.dictionary })
				)
			);
		}
	}, []);

	// Initialize expanded state for all accordions
	useEffect(() => {
		if (level === 0) {
			const initialState = {};
			keys.forEach(key => {
				const item = object[key];
				if (item.type === "level") {
					initialState[key] = true; // defaultExpanded
				}
			});
			setExpanded(initialState);
		}
	}, []);

	const handleExpandAll = () => {
		const newState = {};
		keys.forEach(key => {
			const item = object[key];
			if (item.type === "level") {
				newState[key] = true;
			}
		});
		setExpanded(newState);
	};

	const handleCollapseAll = () => {
		const newState = {};
		keys.forEach(key => {
			const item = object[key];
			if (item.type === "level") {
				newState[key] = false;
			}
		});
		setExpanded(newState);
	};

	const handleAccordionChange = key => (event, isExpanded) => {
		setExpanded({
			...expanded,
			[key]: isExpanded
		});
	};

	const collapseButtonStyle = {
		fontSize: "0.75rem",
		color: "#9e9e9e",
		backgroundColor: "transparent",
		cursor: "pointer",
		transition: "color 0.2s",
		"&:hover": {
			color: "#616161"
		},
		userSelect: "none"
	};

	const accordionSummaryStyle = {
		padding: 1,
		margin: 0,
		minHeight: 0,
		"& .MuiAccordionSummary-content": {
			padding: 0,
			margin: 0,
			minHeight: 0
		},
		"&:hover": {
			backgroundColor: "#f8f9fa"
		},
		"&.Mui-expanded": {
			backgroundColor: "#f1f3f4",
			padding: 1,
			margin: 0,
			minHeight: 0
		},
		"&.Mui-expanded .MuiAccordionSummary-content": {
			padding: 0,
			margin: 0,
			minHeight: 0
		}
	};

	/**
	 * When we have an empty, object display the content in JSON
	 */
	if (lod_.isEmpty(object) && !lod_.isEmpty(item)) {
		let value = lod_.get(metadatasSkeleton, path);

		return (
			<ReactJson
				src={value}
				name={null}
				style={{
					fontSize: "medium"
				}}
				enableClipboard={false}
				displayDataTypes={false}
				onEdit={e => onChangeInputs(path, e)}
				onAdd={e => onChangeInputs(path, e)}
				onDelete={e => onChangeInputs(path, e)}
			/>
		);
	}

	return (
		<MDBox>
			{level === 0 && (
				<MDBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
					<Chip
						icon={<Icon>{localShowAdvanced ? "visibility" : "visibility_off"}</Icon>}
						label={t("FORMS.showAdvanced")}
						size="small"
						variant={localShowAdvanced ? "filled" : "outlined"}
						color={localShowAdvanced ? "info" : "default"}
						onClick={() => setLocalShowAdvanced(!localShowAdvanced)}
						sx={{ cursor: "pointer" }}
					/>
					{collapseActions && (
						<MDBox display="flex" gap={1}>
							<MDTypography variant="button" onClick={handleCollapseAll} sx={collapseButtonStyle}>
								Tout plier
							</MDTypography>
							<MDTypography variant="button" onClick={handleExpandAll} sx={collapseButtonStyle}>
								Tout déplier
							</MDTypography>
						</MDBox>
					)}
				</MDBox>
			)}
			<Grid container spacing={1}>
				{keys.map((key, index) => {
					let item = object[key];
					let display = item.display ?? true;

					const currentPath = path ? `${path}.${key}` : key;

					if (!display) return null;

					// Hide advanced items when showAdvanced is false
					if (!showAdvanced) {
						if (item.advanced === true) return null;
						if (item.type === "level" && !item.advanced && allChildrenAdvanced(item.items))
							return null;
					}

					if (
						!lod_.isNil(hiddenFields) &&
						lod_.isArray(hiddenFields) &&
						hiddenFields.includes(`${path ? `${path}.${key}` : key}`)
					) {
						return null;
					}

					if (lod_.isEmpty(item)) {
						return null;
					}

					// Item system can only be shown to system users
					if (item.system === true && userSystem === false) {
						return null;
					}

					if (item.type === "level" && item.isArray === true) {
						/**
						 * Complex format is when object has sub object layers.
						 * complex -> display as classic form
						 * otherwise, display array like a csv table
						 */
						let hasComplexForm = Object.entries(item.items ?? {}).some(
							([_, subItem]) => subItem.type === "level"
						);

						return (
							<Grid size={{ md: 12 }} key={index}>
								<Accordion
									expanded={expanded[key] ?? true}
									onChange={handleAccordionChange(key)}
									sx={{
										borderRadius: 0,
										boxShadow: "none",
										border:
											(expanded[key] ?? true)
												? "1px solid rgba(200, 200, 200, 1)"
												: "1px solid transparent"
									}}
									style={{
										borderRadius: "0"
									}}
								>
									<AccordionSummary
										expandIcon={<Icon>expand_more</Icon>}
										sx={accordionSummaryStyle}
									>
										<h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 900, color: "#424242" }}>
											{`${getLabelPath(
												baseDictionary ?? object,
												currentPath,
												"Non défini",
												profile?.language
											)} (${(lod_.get(metadatasSkeleton, currentPath) || []).length})`}
										</h3>
									</AccordionSummary>
									<AccordionDetails
										sx={{
											padding: 0,
											paddingTop: hasComplexForm ? "5px" : "0px",
											backgroundColor: "#fafafa"
										}}
									>
										{hasComplexForm && (
											<LittleForm
												object={item.items}
												level={level + 1}
												metadatasSkeleton={metadatasSkeleton}
												handleChange={handleChange}
												path={currentPath}
												listOfApis={listOfApis}
												errorUniqueFields={errorUniqueFields}
												expandedState={expanded}
												setExpandedState={setExpanded}
												collapseActions={collapseActions}
												baseDictionary={baseDictionary ?? object}
												disabled={disabled}
												showAdvanced={showAdvanced}
											/>
										)}
										{!hasComplexForm && (
											<LittleArrayForm
												dictionary={item.items}
												path={currentPath}
												values={lod_.get(metadatasSkeleton, currentPath) || []}
												handleChange={handleChange}
												disabled={disabled}
											/>
										)}
									</AccordionDetails>
								</Accordion>
							</Grid>
						);
					} else if (item.type === "level") {
						const labelLanguageFields = getLabelLanguageFields(item.items);
						const hasLabelLanguageChildren = labelLanguageFields.length > 0;
						return (
							<Grid size={{ md: 12 }} key={index}>
								<Accordion
									expanded={expanded[key] ?? true}
									onChange={handleAccordionChange(key)}
									sx={{
										boxShadow: "none",
										border: "1px solid #f1f3f4"
									}}
								>
									<AccordionSummary
										expandIcon={<Icon>expand_more</Icon>}
										sx={accordionSummaryStyle}
									>
										<h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 900, color: "#424242" }}>
											{getLabelPath(
												baseDictionary ?? object,
												currentPath,
												"Non défini",
												profile?.language
											)}
										</h3>
									</AccordionSummary>
									<AccordionDetails
										sx={{
											padding: "5px",
											backgroundColor: "#fafafa"
										}}
									>
										{hasLabelLanguageChildren && (
											<MDBox display="flex" alignItems="center" gap={1}>
												<Chip
													label={t("ACTIONS.TRANSLATION.translateAll")}
													size="small"
													variant="outlined"
												/>
												<Tooltip
													title={
														levelTranslating
															? t("ACTIONS.TRANSLATION.translation")
															: t("ACTIONS.TRANSLATION.selectLanguageFrom")
													}
													arrow
													placement="top"
												>
													<span>
														<IconButton
															size="small"
															onClick={e =>
																handleTranslateMenuOpen(e, labelLanguageFields, currentPath)
															}
															disabled={levelTranslating || !actions?.translateV2}
															sx={{
																transition: "all 0.3s ease",
																"&:hover": {
																	backgroundColor: "action.hover"
																}
															}}
														>
															{levelTranslating ? (
																<CircularProgress size={24} color="info" />
															) : (
																<Translate sx={{ fontSize: 20 }} />
															)}
														</IconButton>
													</span>
												</Tooltip>
												<Menu
													anchorEl={menuAnchorEl}
													open={Boolean(menuAnchorEl)}
													onClose={handleTranslateMenuClose}
												>
													{languages.map(lang => (
														<MenuItem
															key={lang.code}
															onClick={e => {
																handleTranslateMenuClose(e);

																const { labelLanguageFields, currentPath } = translationContext;
																const sourceLanguageCode = lang.code;

																setLevelTranslating(true);

																const dataset = lod_
																	.chain(labelLanguageFields)
																	.map(fieldKey => {
																		const fieldPath = `${currentPath}.${fieldKey}`;
																		const data = lod_.get(metadatasSkeleton, fieldPath);

																		return {
																			code: fieldPath,
																			data
																		};
																	})
																	.filter(
																		({ data }) =>
																			data && lod_.isObject(data) && Object.keys(data).length > 0
																	)
																	.map(element => {
																		const { code, data } = element;

																		const entryObject = {
																			[sourceLanguageCode]: lod_.get(data, sourceLanguageCode)
																		};

																		return {
																			code,
																			entryObject,
																			sourceLanguage: sourceLanguageCode,
																			callback: ({ code, result, success }) => {
																				if (success) {
																					handleChange(code, result);
																				}
																			}
																		};
																	})
																	.value();

																const inputSchemaValue = Joi.object().pattern(
																	Joi.string().trim().required().description("Code langue").empty(),
																	Joi.string()
																		.trim()
																		.required()
																		.description("Texte traduit")
																		.min(1)
																		.empty()
																);
																const inputSchemaValueString = `Joi.object().pattern(
																Joi.string().trim().required().description("Code langue").empty(),
																Joi.string().trim().required().description("Texte traduit").min(1).empty()
															)`;

																translateV2Dataset(
																	inputSchemaValue,
																	inputSchemaValueString,
																	dataset,
																	() => {
																		setLevelTranslating(false);
																		setTranslationContext(null);
																	}
																);
															}}
														>
															{lang.logoURL && (
																<img
																	src={lang.logoURL}
																	alt={lang.code}
																	style={{
																		width: "20px",
																		height: "20px",
																		borderRadius: "50%",
																		marginRight: "10px"
																	}}
																/>
															)}
															<MDTypography variant="body2">
																{lang.name} ({lang.code})
															</MDTypography>
														</MenuItem>
													))}
												</Menu>
											</MDBox>
										)}
										<LittleFormBusiness
											item={item}
											object={item.items}
											level={level + 1}
											metadatasSkeleton={metadatasSkeleton}
											handleChange={handleChange}
											path={currentPath}
											listOfApis={listOfApis}
											errorUniqueFields={errorUniqueFields}
											expandedState={expanded}
											setExpandedState={setExpanded}
											collapseActions={collapseActions}
											baseDictionary={baseDictionary ?? object}
											disabled={disabled}
											context={context || metadatasSkeleton}
											actions={actions}
											languages={languages}
											showAdvanced={showAdvanced}
										/>
									</AccordionDetails>
								</Accordion>
							</Grid>
						);
					} else {
						return (
							<FormInput
								key={index}
								item={item}
								listOfDico={keyDictionary}
								datas={metadatasSkeleton}
								handleChange={handleChange}
								regexEmail={regexEmail}
								path={currentPath}
								listOfApis={listOfApis}
								errorUniqueFields={errorUniqueFields}
								disabled={disabled}
								context={context || metadatasSkeleton}
								actions={actions}
								language={language}
								languages={languages}
							/>
						);
					}
				})}
			</Grid>
		</MDBox>
	);
};

/**
 * Component for create a form from a dictionary
 */
export function LittleForm({
	// Props given by parent
	item = {},
	object,
	metadatasSkeleton,
	handleChange,
	hiddenFields = [],
	level = 0,
	path = null,
	listAPIs = null,
	collapseActions = false,
	disabled = false,
	// Internal state, passed through recursion
	errorUniqueFields,
	expandedState = {},
	setExpandedState = null,
	baseDictionary = null,
	display = "column",
	flex = 1,
	context = null,
	showAdvanced: showAdvancedProp
}) {
	const { languages } = useLanguages();
	/**
	 * Actions
	 */
	const { translateV2, translateV2Dataset } = useTranslateActions();
	const actions = { translateV2, translateV2Dataset };

	return (
		<LittleFormBusiness
			item={item}
			object={object}
			metadatasSkeleton={metadatasSkeleton}
			handleChange={handleChange}
			hiddenFields={hiddenFields}
			level={level}
			path={path}
			listAPIs={listAPIs}
			errorUniqueFields={errorUniqueFields}
			display={display}
			flex={flex}
			context={context}
			actions={actions}
			languages={languages}
			collapseActions={collapseActions}
			disabled={disabled}
			expandedState={expandedState}
			setExpandedState={setExpandedState}
			baseDictionary={baseDictionary}
			showAdvanced={showAdvancedProp}
		/>
	);
}
